<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="schedules_container"
      :addButtonEntityId="teamId"
      :addButtonEntityType="entityType"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      @add="goToAddSchedulePage"
      @edit="goToEditSchedulePage($event.id)"
      @delete="showDeleteDialog($event.id)"
    />
  </div>
</template>

<script>
import ComponentTable from '@/components/table/Table';
import { TableName } from '@/enums/tableName.enum';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/constants';

// @vuese
// Lista harmonogramów
// @group Team
export default {
  mixins: [
    listMixin('schedule', {
      listError: 'messages.schedule.listError',
      getError: 'messages.schedule.getError',
      added: 'messages.schedule.added',
      addError: 'messages.schedule.addError',
      updated: 'messages.schedule.updated',
      updateError: 'messages.schedule.updateError',
      deleteConfirm: 'messages.schedule.deleteConfirm',
      deleted: 'messages.schedule.deleted',
      deleteError: 'messages.schedule.deleteError'
    })
  ],
  components: { ComponentTable },

  data() {
    return {
      entityType: TableName.Team,
      columns: [
        { name: 'name', displayName: 'columns.name' },
        { name: 'description', displayName: 'columns.description' },
        { name: 'start', displayName: 'columns.start' },
        { name: 'end', displayName: 'columns.end' }
      ],
      actions: [
        { ...EDIT_ACTION, entityType: 'schedulesContainer' },
        { ...DELETE_ACTION, entityType: 'schedulesContainer' }
      ]
    };
  },
  methods: {
    // @vuese
    // Przechodzi do widoku dodawania treningu
    goToAddSchedulePage() {
      this.$router.push({ name: 'addTeamSchedule' });
    },
    // @vuese
    // Przechodzi do widoku edycji treningu
    goToEditSchedulePage(scheduleId) {
      this.$router.push({ name: 'editTeamSchedule', params: { scheduleId } });
    }
  },
  computed: {
    teamId() {
      return this.$route.params.teamId;
    }
  }
};
</script>
